
import TableCampaignList from "components/Campaign";
import Main from "layouts/Main";


function CampaignPage() {

  return (
    <>
    <Main namePage="แคมเปญ"  >
      <div className="layout-content">
        <TableCampaignList/>
      </div>
      </Main>
    </>
  );
}

export default CampaignPage;